module.exports = __webpack_public_path__ + "img/drizzle.1ee49c93.svg";